module.exports = __webpack_public_path__ + "static/media/295265.f77e8f99.png";